import RjsfForm from "@rjsf/core";
import type { RJSFSchema, UiSchema } from "@rjsf/utils";
import validator from "@rjsf/validator-ajv8";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

import "./task-form.css";

export type TaskFormProps = {
  readonly schema: Readonly<Record<string, unknown>>;
  readonly uiSchema: Readonly<Record<string, unknown>>;
  readonly formData: Readonly<Record<string, unknown>>;
  readonly onSubmit: (_formData: Record<string, unknown>) => void;
  /** 渡したときだけ下書き保存ボタンを出す。 */
  readonly onSaveDraft?: (_formData: Record<string, unknown>) => void;
  /** 送信ボタンの文言。既定は「提出する」（承認画面では「承認」を渡す）。 */
  readonly submitLabel?: string;
  readonly isSubmitting?: boolean;
};

/**
 * SpiffArena が返す JSON Schema / UI Schema からフォームを描画する。
 *
 * スキーマはプロセスモデル側の資産なので、UI 側でフォームを手書きしない
 * （フローが増えても画面追加が要らない）。バリデーションは ajv に委ねる。
 */
export function TaskForm({
  schema,
  uiSchema,
  formData,
  onSubmit,
  onSaveDraft,
  submitLabel,
  isSubmitting = false,
}: TaskFormProps) {
  const { t } = useTranslation("common");
  // 下書き保存は「今の入力値」が必要なので、submit 経路とは別に保持する
  const [current, setCurrent] = useState<Record<string, unknown>>({
    ...formData,
  });

  return (
    <RjsfForm
      schema={schema as RJSFSchema}
      uiSchema={uiSchema as UiSchema}
      formData={current}
      validator={validator}
      showErrorList={false}
      onChange={(event) =>
        setCurrent((event.formData ?? {}) as Record<string, unknown>)
      }
      onSubmit={(event) =>
        onSubmit((event.formData ?? {}) as Record<string, unknown>)
      }
    >
      <div className="mt-4 flex gap-2">
        <Button type="submit" disabled={isSubmitting}>
          {submitLabel ?? t("newApplication.submit")}
        </Button>
        {onSaveDraft ? (
          <Button
            type="button"
            variant="outline"
            disabled={isSubmitting}
            onClick={() => onSaveDraft(current)}
          >
            {t("newApplication.saveDraft")}
          </Button>
        ) : null}
      </div>
    </RjsfForm>
  );
}
